import { useMemo } from "react";
import { fmtMoney, type BoardRow } from "@/lib/event-board";
import { summarize } from "@/lib/event-filters";

/** "N events · G guests · $X in quotes", plus what's still owing (#1557). */
export function EventsSummary({ rows }: { rows: BoardRow[] }) {
  const s = useMemo(() => summarize(rows), [rows]);
  return (
    <p aria-live="polite" className="text-[13.5px] tabular-nums text-muted-foreground">
      <b className="text-foreground">{s.events}</b> event{s.events === 1 ? "" : "s"} ·{" "}
      <b className="text-foreground">{s.guests}</b> guests · <b className="text-foreground">{fmtMoney(s.quoted)}</b> in
      quotes
      {s.owing > 0 && (
        <>
          {" "}
          · <b className="text-foreground">{fmtMoney(s.owing)}</b> still owing on accepted quotes
        </>
      )}
    </p>
  );
}
